import { type FC, memo } from 'react';
import styles from './wallet-connected.module.scss';
import downIcon from '@assets/images/header/down.svg';
import { useToggle, useWindowSize } from 'react-use';

import { useCurrentWallet, useResolveSuiNSName } from '@mysten/dapp-kit';
import WalletList from './wallet-list';
import { formatAddress } from '@mysten/sui/utils';
import ParrotDrawer from '@ui/parrot/drawer';
import Popover from '@ui/parrot/popover';
import { useAddress } from '@hooks/use-address';

const WalletConnected: FC = () => {
  const { width } = useWindowSize();
  const [showMenu, toggleShowMenu] = useToggle(false);
  return (
    <>
      {width > 640 ? (
        <Popover
          content={<WalletList toggleShowMenu={toggleShowMenu} />}
          trigger={'click'}
          open={showMenu}
          onOpenChange={toggleShowMenu}
        >
          <>
            <WalletConnectedContent showMenu={showMenu} />
          </>
        </Popover>
      ) : (
        <>
          <WalletConnectedContent showMenu={showMenu} onClick={toggleShowMenu} />
          <ParrotDrawer
            onClose={toggleShowMenu}
            open={showMenu}
            closable={false}
            height={'40%'}
            maskClosable={true}
          >
            <WalletList toggleShowMenu={toggleShowMenu} />
          </ParrotDrawer>
        </>
      )}
    </>
  );
};

interface OwnProps extends React.HTMLAttributes<HTMLDivElement> {
  showMenu: boolean;
}

const WalletConnectedContent: FC<OwnProps> = ({ showMenu, ...props }) => {
  const address = useAddress();
  const wallet = useCurrentWallet();
  const suiNames = useResolveSuiNSName(address);

  return (
    <div {...props} className={`${styles.button} ${showMenu ? styles.active : ''}`}>
      <img src={wallet.currentWallet?.icon} className={styles.wallet_icon} />
      <span>{suiNames.data ? suiNames.data : address ? formatAddress(address) : ''}</span>
      <img src={downIcon} className={styles.arrow_icon} />
    </div>
  );
};

export default memo(WalletConnected);
